import React, { Component } from "react";
import {
  Button,
  Card,
  Row,
  Col,
  Table,
  Image,
  Modal,
  Container,
  Form,
} from "react-bootstrap";

import DeleteDeliveryStatus from "./DeleteDeliveryStatus";
import ViewDeliveryStatus from "./ViewDeliveryStatus";
import EditDeliveryStatus from "./EditDeliveryStatus";

import Switch from "react-switch";
import ReactPaginate from "react-paginate";
var dateFormat = require("dateformat");

class DeliveryStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showaddDelivery: false,
      statusname: "",
      description: "",
      sortOrder: "",
      isActive: true,

      statusnameError: "",
      descriptionError: "",
      sortOrderError: "",

      statuses: "",
      showDelModal: false,
      showDetailModal: false,
      showEditModal: false,

      page: 0,
      perPage: 10,
    };
  }

  componentDidMount() {
    this.props.getDeliverystatus({ page: undefined });
  }

  //For pagination
  handleStatuspage = (e) => {
    const selectedstatusPage = e.selected;
    this.props.statuspageSelected({ page: selectedstatusPage + 1 });
    this.setState({ page: selectedstatusPage });
  };

  resetPage = () => {
    this.setState({ page: 0 });
  };

  //For Modal Box
  handleaddDeliverystatus = () => {
    this.setState({
      ...this.state,
      showaddDelivery: true,
    });
  };

  closeAdddelivery = () => {
    this.setState({
      ...this.state,
      statusname: "",
      description: "",
      sortOrder: "",
      isActive: true,
      showaddDelivery: false,
    });
  };

  handleChange = () => {
    this.setState({
      ...this.state,
      isActive: !this.state.isActive,
    });
  };

  onChange = (ev) => {
    let name = ev.target.name;
    let val = ev.target.value;

    if (name === "statusname") {
      this.setState({
        ...this.state,
        statusname: val,
        statusnameError: "",
      });
    } else if (name === "desc") {
      this.setState({
        ...this.state,
        description: val,
        descriptionError: "",
      });
    } else if (name === "sortorder") {
      this.setState({
        ...this.state,
        sortOrder: val,
        sortOrderError: "",
      });
    }
  };

  //For deletion
  handledeleteDeliverystatus = (item) => {
    this.setState({
      ...this.state,
      statuses: item,
      showDelModal: true,
    });
  };

  closeDelModal = () => {
    this.setState({
      ...this.state,
      showDelModal: false,
    });
  };

  //For detail view
  handleviewDeliverystatus = (item) => {
    this.setState({
      ...this.state,
      statuses: item,
      showDetailModal: true,
    });
  };

  closeDetailModal = () => {
    this.setState({
      ...this.state,
      showDetailModal: false,
    });
  };

  //For edit
  handleeditDeliverystatus = (item) => {
    this.setState({
      ...this.state,
      showEditModal: true,
      statuses: item,
    });
  };

  closeEditModal = () => {
    this.setState({
      ...this.state,
      showEditModal: false,
    });
  };

  //For posting
  validate = () => {
    let isError = false;
    const { statusname, description, sortOrder } = this.state;

    let reg = /\d/;
    const errmsg1 = "This field is mandatory";
    const errmsg = "Only numerals allowed";

    const errors = {
      statusnameError: "",
      descriptionError: "",
      sortOrderError: "",
    };

    if (statusname === "") {
      isError = true;
      errors.statusnameError = errmsg1;
    }
    if (description === "") {
      isError = true;
      errors.descriptionError = errmsg1;
    }
    if (sortOrder === "") {
      isError = true;
      errors.sortOrderError = errmsg1;
    }
    if (sortOrder != "" && !reg.test(sortOrder)) {
      isError = true;
      errors.sortOrderError = errmsg;
    }

    this.setState({
      ...this.state,
      ...errors,
    });

    return isError;
  };

  add = () => {
    const { statusname, description, sortOrder, isActive } = this.state;
    let data = {
      statusname: statusname,
      statusdesc: description,
      sortorder: sortOrder,
      active: isActive,
    };

    let validate = this.validate();
    if (!validate) {
      this.props.postDeliverystatus(data);

      this.setState({
        ...this.state,
        statusname: "",
        description: "",
        sortOrder: "",
        isActive: true,
        showaddDelivery: false,
      });
    }
  };

  render() {
    const count = this.props.deliveryStatusCount;
    let p = this.state.page + 1;
    let deliveryStatusPageCount = Math.ceil(count / this.state.perPage);

    //Destructuring
    const {
      page,
      showaddDelivery,
      statusname,
      description,
      sortOrder,
      isActive,
      statusnameError,
      descriptionError,
      sortOrderError,
      showDelModal,
      statuses,
      showDetailModal,
      showEditModal,
    } = this.state;
    const { deliveryStatus, deleteStatus, editDeliverystatus } = this.props;
    const {
      handleStatuspage,
      handleaddDeliverystatus,
      handleviewDeliverystatus,
      handleeditDeliverystatus,
      handledeleteDeliverystatus,
      closeAdddelivery,
      onChange,
      add,
      handleChange,
      closeDelModal,
      closeDetailModal,
      closeEditModal,
      resetPage,
    } = this;

    console.log(localStorage.getItem("token"));
    return (
      <div>
        <Modal
          show={showaddDelivery}
          onHide={closeAdddelivery}
          animation={false}
          keyboard={false}
          backdrop="static"
          centered={true}
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>Add Delivery Statuses</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col lg={12}>
                  <Form>
                    <div style={{ maxWidth: 280, margin: "auto" }}>
                      <div>
                        <Form.Group controlId="statusName">
                          <Form.Label> Status </Form.Label>
                          <Form.Control
                            type="text"
                            autoComplete="off"
                            name="statusname"
                            onChange={onChange}
                            value={statusname}
                          />
                          <div className="errStyle">{statusnameError}</div>
                        </Form.Group>
                      </div>

                      <div>
                        <Form.Group controlId="desc">
                          <Form.Label>Description</Form.Label>
                          <Form.Control
                            as="textarea"
                            name="desc"
                            autoComplete="off"
                            onChange={onChange}
                            value={description}
                          />
                          <div className="errStyle">{descriptionError}</div>
                        </Form.Group>
                      </div>

                      <div>
                        <Form.Group controlId="sortorder">
                          <Form.Label>Sort Order</Form.Label>
                          <Form.Control
                            type="number"
                            min="0"
                            name="sortorder"
                            autoComplete="off"
                            onChange={onChange}
                            value={sortOrder}
                          />
                          <div className="errStyle">{sortOrderError}</div>
                        </Form.Group>
                      </div>

                      <div>
                        <label style={{ display: "flex", marginTop: "8px" }}>
                          <div style={{ marginRight: "30px" }}>
                            <span>Active</span>
                          </div>
                          <div style={{ marginTop: "-5px" }}>
                            <Switch
                              onChange={handleChange}
                              onColor="#20a8d8"
                              checked={isActive}
                            />
                          </div>
                        </label>
                      </div>
                    </div>
                  </Form>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button type="submit" onClick={add}>
              Add
            </Button>
          </Modal.Footer>
        </Modal>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={6} md={6} lg={6} style={{ margin: "auto" }}>
                <h3>Delivery Status</h3>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="countryRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">{count ? count : 0}</span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              <Button
                style={{ marginBottom: "15px" }}
                onClick={() => handleaddDeliverystatus()}
              >
                <i className="fa fa-plus fa-md"></i>
                <span style={{ marginLeft: "5px", fontWeight: "bold" }}>
                  ADD
                </span>
              </Button>
            </div>
            <div>
              <Table responsive className="cmnMainTable" bordered striped>
                <thead>
                  <tr className="cmnMainTableHd">
                    <th>SL NO</th>
                    <th>Status Name</th>
                    <th>Description</th>
                    <th>Sort Order</th>
                    <th>ACTIVE</th>
                    <th>CREATED DATE</th>
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {deliveryStatus &&
                    deliveryStatus.map((item, i) => (
                      <tr key={i}>
                        <td className="cmn_Cap">{10 * (p - 1) + i + 1}</td>
                        <td className="cmn_Cap ">
                          {item !== null && item.name}
                        </td>
                        <td className="cmn_Cap commonDesc">
                          {item !== null && item.disc}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.sortOrder}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.isActive ? "Yes" : "No"}
                        </td>
                        <td className="cmn_Cap">
                          {item.createdAt !== null &&
                            dateFormat(item.createdAt, "mediumDate")}
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <i
                              className="fa fa-eye fa-lg "
                              onClick={() => handleviewDeliverystatus(item)}
                            ></i>
                            <ViewDeliveryStatus
                              showDetailModal={showDetailModal}
                              closeDetailModal={closeDetailModal}
                              statuses={statuses}
                            />
                            <i
                              className="fa fa-edit fa-lg "
                              style={{
                                paddingLeft: 10,
                              }}
                              onClick={() => handleeditDeliverystatus(item)}
                            ></i>
                            <EditDeliveryStatus
                              showEditModal={showEditModal}
                              closeEditModal={closeEditModal}
                              statuses={statuses}
                              editDeliverystatus={editDeliverystatus}
                              resetPage={resetPage}
                            />

                            {/* <i
                              className="fa fa-trash fa-lg"
                              style={{
                                paddingLeft: 10
                              }}
                              onClick={() => handledeleteDeliverystatus(item)}
                            ></i>
                             <DeleteDeliveryStatus
                              showDelModal={showDelModal}
                              statuses={statuses}
                              closeDelModal={closeDelModal}
                              deleteStatus={deleteStatus}
                              resetPage={resetPage}
                            />  */}
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
            {(deliveryStatus === undefined ||
              (deliveryStatus && deliveryStatus.length === 0)) && (
              <div>
                <div className="noDataImgDiv">
                  <Image
                    className="noDataImg"
                    src={require("../../assets/img/nodata4.png")}
                  />
                </div>
                <div className="noDataTextDiv">No Delivery Status Found</div>
              </div>
            )}
          </Card.Body>
          {deliveryStatusPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={deliveryStatusPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handleStatuspage}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}

export default DeliveryStatus;
